// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Clients_wrapper__-5F6k","item":"Clients_item__13a15","inView":"Clients_inView__2770X","fake":"Clients_fake__3nzX7","img":"Clients_img__3ui-p"};